// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__RO22B","colBig":"styles_colBig__1aWvT","colSmall":"styles_colSmall__2bBAl","shopifyNameWrapper":"styles_shopifyNameWrapper__1uLzL"};